<div class="body2Text"><slot></slot></div>